/**
 * Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SearchUserTransactionTypeResponse } from './search-user-transaction-type-response';
import { SearchUserTransactionStatusResponse } from './search-user-transaction-status-response';


export interface SearchUserTransactionsResponseItem { 
    id: string;
    currencyName: string;
    currencyTicker: string;
    chainCode: string;
    chainName: string;
    accountName: string;
    status: SearchUserTransactionStatusResponse;
    type: SearchUserTransactionTypeResponse;
    amount: number;
    commission?: number | null;
    createdDate: string;
    isTemporary: boolean;
    rejectReason?: string | null;
}

